import { FC } from 'react'
import styled from 'styled-components'
import { Form as AntdForm, FormInstance } from 'antd'
import { AdlSectionExtended } from '@lmc/ts-common'
import { CarePlanSection } from './CarePlanSection'

type Props = {
  sections?: AdlSectionExtended[]
  form?: FormInstance<unknown>
  submitForm?: () => void
  initialValues?: Record<string, string>
  isVieMode?: boolean
}

export const CarePlanSectionContainer: FC<Props> = ({
  sections,
  submitForm,
  initialValues,
  isVieMode,
  form,
}) => {
  return (
    <Wrapper>
      <AntdForm
        name="register"
        onFinish={submitForm}
        initialValues={initialValues}
        form={form}
      >
        {sections?.map((section) => {
          if (isVieMode && !section.value) {
            return null
          }

          return (
            <CarePlanSection
              section={section}
              key={section?.key}
              isVieMode={isVieMode}
              value={section.value}
            />
          )
        })}
      </AntdForm>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 14px;
`
